<dx-scroll-view height="100%" width="100%" class="with-footer single-card">
    <ng-content></ng-content>
  </dx-scroll-view>
